import styled from '@emotion/styled';

import { helper } from '@myrealtrip/frontend-weblog';
import { media } from '@myrealtrip/modash';

import Tab from '~components/tab';
import useScrollPosition from '~hooks/useScrollPosition';
import { RAIL_EUROPE_TRAIN_CATEGORY_TYPE } from '~constants/pointToPointTicket';
import { WeblogEventName, WeblogPageCategory, WeblogScreenName } from '~constants/weblog';

import type { RailEuropeTrainCategoryType } from '~types/queryParam';

const { sendClickLog } = helper;

interface Props {
  selectedCategory: RailEuropeTrainCategoryType;
  onChangeCategory: (category: RailEuropeTrainCategoryType) => void;
}

const tabs = [
  {
    key: RAIL_EUROPE_TRAIN_CATEGORY_TYPE.TICKET,
    label: '구간권',
    tabProps: {
      style: { margin: '0 12px' },
    },
  },
  {
    key: RAIL_EUROPE_TRAIN_CATEGORY_TYPE.PASS,
    label: '패스',
    tabProps: {
      style: { margin: '0 12px' },
    },
  },
];

const SearchCategoryTab = ({ selectedCategory, onChangeCategory }: Props) => {
  const { saveScrollPosition, restoreScrollPosition } = useScrollPosition([
    RAIL_EUROPE_TRAIN_CATEGORY_TYPE.TICKET,
    RAIL_EUROPE_TRAIN_CATEGORY_TYPE.PASS,
  ]);

  const handleChangeCategory = (newCategory: RailEuropeTrainCategoryType) => {
    saveScrollPosition(selectedCategory);

    sendClickLog({
      pageCategory: WeblogPageCategory.EUROPE_TRAIN_TICKET_MAIN,
      screenName: WeblogScreenName.EUROPE_TRAIN_TICKET_MAIN,
      eventName: WeblogEventName.TAB_CLICK,
      itemKind: 'button',
      itemName: newCategory === RAIL_EUROPE_TRAIN_CATEGORY_TYPE.TICKET ? '구간권' : '패스권',
    });

    onChangeCategory(newCategory);

    restoreScrollPosition(newCategory);
  };

  return (
    <Container>
      <CategoryTabBar
        tabs={tabs}
        selectedTabKey={selectedCategory}
        onChangeTab={handleChangeCategory}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.s100};
`;

const CategoryTabBar = styled(Tab.Bar<RailEuropeTrainCategoryType>)`
  ${media.mobile} {
    padding: 0 20px;
  }
`;

export default SearchCategoryTab;
